module.exports = __webpack_public_path__ + "219696107f7ffe38f4eb60651cb4287c.svg";